var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPersonCodeSmallCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5C15.825 10.5 16.5 11.175 16.5 12C16.5 12.825 15.825 13.5 15 13.5C14.175 13.5 13.5 12.825 13.5 12C13.5 11.175 14.175 10.5 15 10.5ZM15 17.25C17.025 17.25 19.35 18.2175 19.5 18.75V19.5H10.5V18.7575C10.65 18.2175 12.975 17.25 15 17.25ZM15 9C13.3425 9 12 10.3425 12 12C12 13.6575 13.3425 15 15 15C16.6575 15 18 13.6575 18 12C18 10.3425 16.6575 9 15 9ZM15 15.75C12.9975 15.75 9 16.755 9 18.75V21H21V18.75C21 16.755 17.0025 15.75 15 15.75Z",
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.75,
    cy: 5.25,
    r: 5.25,
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.775 6.975L22.05 5.25L23.775 3.525L23.25 3L21 5.25L23.25 7.5L23.775 6.975ZM25.725 6.975L27.45 5.25L25.725 3.525L26.25 3L28.5 5.25L26.25 7.5L25.725 6.975Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonCodeSmallCircle);
export default __webpack_public_path__ + "static/media/ic_person-code_small_circle.efdea149e8bbd88319193009ab838034.svg";
export { ForwardRef as ReactComponent };